var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-lock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 18,
    height: 11,
    rx: 2,
    ry: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.da0ef2f6c89c7b956e2bb214c440592e.svg";
export { ForwardRef as ReactComponent };